import { render } from "./Gallery.vue?vue&type=template&id=1f96e952&scoped=true&bindings={\"isLoading\":\"data\",\"error\":\"data\",\"visible\":\"data\",\"index\":\"data\",\"galleryHeight\":\"data\",\"gallery\":\"options\",\"loadCategories\":\"options\",\"handleError\":\"options\",\"showImg\":\"options\",\"handleHide\":\"options\",\"setGalleryHeight\":\"options\"}"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=1f96e952&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f96e952"

export default script